import { render, staticRenderFns } from "./AlarmItem.vue?vue&type=template&id=c0ad52a2&scoped=true"
import script from "./AlarmItem.vue?vue&type=script&lang=js"
export * from "./AlarmItem.vue?vue&type=script&lang=js"
import style0 from "./AlarmItem.vue?vue&type=style&index=0&id=c0ad52a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ad52a2",
  null
  
)

export default component.exports